var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqChatbot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "share [#1099]"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-420.000000, -3319.000000)",
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.002,3170.875 C378.899,3170.875 378.002,3169.978 378.002,3168.875 C378.002,3167.772 378.899,3166.875 380.002,3166.875 C381.105,3166.875 382.002,3167.772 382.002,3168.875 C382.002,3169.978 381.105,3170.875 380.002,3170.875 L380.002,3170.875 Z M371.141,3172.551 C370.608,3171.868 369.998,3171.365 368.998,3171.141 L368.998,3166.859 C369.998,3166.619 370.72,3166.066 371.257,3165.309 L376.08,3168.093 C375.976,3168.614 375.971,3169.145 376.089,3169.704 L371.141,3172.551 Z M368.002,3177 C366.899,3177 366.002,3176.103 366.002,3175 C366.002,3173.897 366.899,3173 368.002,3173 C369.105,3173 370.002,3173.897 370.002,3175 C370.002,3176.103 369.105,3177 368.002,3177 L368.002,3177 Z M365.998,3163 C365.998,3161.897 366.998,3161 367.998,3161 C370.998,3161 370.998,3165 367.998,3165 C366.998,3165 365.998,3164.103 365.998,3163 L365.998,3163 Z M380.002,3164.875 C378.781,3164.875 377.702,3165.434 376.968,3166.296 L371.961,3163.405 C372.214,3160.919 370.271,3159 368.002,3159 C365.793,3159 364,3160.791 364,3163 C364,3164.862 364.998,3166.412 366.998,3166.859 L366.998,3171.141 C364.998,3171.587 364,3173.138 364,3175 C364,3177.209 365.792,3179 368.001,3179 C370.363,3179 372.326,3176.928 371.941,3174.399 L376.997,3171.49 C377.73,3172.332 378.798,3172.875 380.002,3172.875 C382.211,3172.875 384.002,3171.084 384.002,3168.875 C384.002,3166.666 382.211,3164.875 380.002,3164.875 L380.002,3164.875 Z",
    id: "share-[#1099]"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqChatbot);
export default __webpack_public_path__ + "static/media/faq_chatbot.a2d4d5ed97f443273f34799615bb310f.svg";
export { ForwardRef as ReactComponent };